import { Card, Fade, Grow, LinearProgress } from "@mui/material";
import { Outlet } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import { DurableLogo } from "../components/shared/DurableLogo";
import { LocalStorageLocation } from "../LocalStorage";

/**
 * A loading page that displays while the dom builds
 *
 * @param {{ loading: boolean }} { loading }
 * @return {*}
 */
function LoadingPage({ loading }: { loading: boolean }) {
  // Always use dark mode
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [darkMode, setDarkMode] = useLocalStorageState<boolean>(
    LocalStorageLocation.DarkMode,
    {
      defaultValue: true
    }
  );

  return (
    <>
      <Fade in={loading} timeout={200} unmountOnExit>
        <Card
          id="loading-screen"
          square
          className={`absolute left-0 top-0 flex h-full w-full flex-col
          items-center justify-center`}
        >
          <LinearProgress color="primary" className="absolute top-0 w-full" />
          <Grow in={loading} timeout={200} unmountOnExit>
            <div>
              <DurableLogo variant="dynamic" type="logo" size={200} />
            </div>
          </Grow>
        </Card>
      </Fade>
      <span style={{ display: loading ? "none" : "block" }}>
        <Outlet />
      </span>
    </>
  );
}

export default LoadingPage;
